import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckPermissions } from './Shared';

const ReportTruckChecksGroupedData = () => {
    let navigate = useNavigate();
    const [errors, setErrors] = React.useState<{ [key: string]: string }>({});
    const [loading, setLoading] = React.useState(true);
    const [scheduleDate, setScheduleDate] = React.useState("");

    React.useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        var hasPermission = await CheckPermissions("RunReports");
        if (hasPermission) {
            setLoading(false);
        } else {
            navigate("/accessdenied")
        }
    }

    const handleScheduleDateChange = (e: any) => {
        let error = errors;
        delete error["scheduleDate"];
        setErrors(error);

        setScheduleDate(e.target.value);
    }

    const validate = () => {
        let errorList: any = {};
        let formIsValid = true;

        if (!scheduleDate) {
            formIsValid = false;
            errorList["scheduleDate"] = "Schedule Date is required";
        }

        setErrors(errorList);
        return formIsValid;
    }

    const runReport = (e: any) => {
        e.preventDefault();
        //run the report and export the data

        if (validate()) {
            var url = "/report/TruckChecksGrouped/" + scheduleDate + "/-1/-1/-1/-1";
            window.open(url, '_blank');
        }
    }

    const renderDetails = (
        <div>
            <div>
                <h1>Truck/Tool Checklist Report</h1>
            </div>
            <div className="marginTop20">
                <span>Select the Schedule Date to run the report. </span>
            </div>
            <div>
                <label className="input-group" htmlFor="scheduleDate">
                    <span className="label">Schedule Date</span>
                    <input type='date' id="scheduleDate" name="scheduleDate" className='input' value={scheduleDate} onChange={(e) => handleScheduleDateChange(e)}></input>
                </label>
                <span className={errors["scheduleDate"] ? "label errors marginLeftLabel" : "hidden"}>{errors["scheduleDate"]}</span>
            </div>
            <button className="defaultbutton marginLeftLabel" type='button' onClick={runReport}>Run Report</button>
        </div>
    );

    let contents = loading
        ? <p><em>Loading...</em></p>
        : renderDetails;

    return (<div>
        {contents}
    </div>)

};

export default ReportTruckChecksGroupedData;